// External Dependencies
import styled from 'styled-components';

// Internal Dependencies
import { formatAddress } from 'utils/lib/format_address';
import { formatPhoneNumber } from 'utils/lib/format_phone_number';

// Local Typings
interface Props {
  addressOne?: string | null;
  addressTwo?: string | null;
  city?: string | null;
  className?: string;
  email?: string | null;
  phoneNumber?: string | null;
  state?: string | null;
  zipcode?: string | null;
}

// Local Variables
const StyledAddress = styled.address({
  fontStyle: 'normal',
});

// Component Definition
const Address = ({
  addressOne,
  addressTwo,
  city = null,
  className,
  email,
  phoneNumber,
  state = null,
  zipcode = null,
  ...otherProps
}: Props): JSX.Element => (
  <StyledAddress
    className={className}
    {...otherProps}
  >
    {email && <div>{email}</div>}
    {addressOne && <div>{addressOne}</div>}
    {addressTwo && <div>{addressTwo}</div>}
    {(city || state || zipcode) && (
      <div>{formatAddress({ city, state, zipcode })}</div>
    )}
    {phoneNumber && <div>{formatPhoneNumber(phoneNumber)}</div>}
  </StyledAddress>
);

export default Address;
